import {styled} from '@mui/material/styles'

export const ErrorBox = styled('div')(({theme}) => ({
  position: 'relative',
  top: '169px',
  fontFamily: theme.typography.fontFamily,
  fontSize: '222px',
  textAlign: 'center',
  letterSpacing: '0.214286px',
  fontWeight: theme.typography.fontWeightRegular,
  color: theme.palette.hpBaseLighter
}))

export const ErrorMsg = styled('div')(({theme}) => ({
  position: 'relative',
  top: '280px',
  color: theme.palette.hpBlack,
  fontFamily: theme.typography.fontFamily,
  textAlign: 'center',
  fontWeight: theme.typography.fontWeightSemibold,
  fontSize: theme.typography.kpiMedium.fontSize
}))

export const ErrorLink = styled('div')(({theme}) => ({
  position: 'relative',
  fontFamily: theme.typography.fontFamily,
  textAlign: 'center',
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.h6.fontSize,
  top: '280px',
  color: theme.palette.hpPrimaryMain
}))

export const ErrorMainStyle = styled('div')(({theme}) => ({
  position: 'relative',
  height: '500px',
  backgroundColor: theme.palette.hpWhite,
  borderRadius: theme.spacing(2)
}))
